import { tv } from "../../../variants/tv.js";
const baseTransition = 'transition-transform [transition-duration:var(--transition-duration-medium)] ease-in-out';
const chevronVariants = tv({
    slots: {
        group: baseTransition,
        chevronLeft: `${baseTransition} origin-[10px_12px]`,
        chevronRight: `${baseTransition} origin-[14px_12px]`
    },
    defaultVariants: {
        isOpen: false
    },
    variants: {
        isOpen: {
            true: {
                chevronLeft: '-rotate-90',
                chevronRight: 'rotate-90'
            }
        }
    }
});
export { chevronVariants };
